import { render, staticRenderFns } from "./ValidatedCreditMemos.vue?vue&type=template&id=24df8220&scoped=true"
import script from "./ValidatedCreditMemos.vue?vue&type=script&lang=js"
export * from "./ValidatedCreditMemos.vue?vue&type=script&lang=js"
import style0 from "./ValidatedCreditMemos.vue?vue&type=style&index=0&id=24df8220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24df8220",
  null
  
)

export default component.exports